import config from '../../../../config';
import CookieCreator from './CookieCreator';
import { setCookie } from '../../Providers/SetCookieApi';

export default class NodeCookie extends CookieCreator {
    constructor() {
        super();
        this.domain = config.nodeApi;
    }

    sendCookie(cookieParams) {
        return setCookie(cookieParams, this.domain);
    }

    removeCookies(cookiesList) {
       return setCookie({ flag: 'remove', cookiesToRemove: JSON.stringify(cookiesList) }, this.domain);
    }
}


// WEBPACK FOOTER //
// ./src/Common/Helpers/TrackingAffiliate/NodeCookie.js